import script from "./series.vue?vue&type=script&setup=true&lang=js"
export * from "./series.vue?vue&type=script&setup=true&lang=js"

import "./series.vue?vue&type=style&index=0&id=3c9c13f5&lang=less&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c9c13f5"]])

export default __exports__